import React from "react";
import { ConfirmationModal } from "@folio/stripes/components";
import { useIntl } from "react-intl";
/** Asks "Chcete opravdu vytvořit další produkt?" before creating another product of a title. */
export var CreateAnotherProductConfirmModal = function (_a) {
    var open = _a.open, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(ConfirmationModal, { open: open, heading: formatMessage({
            id: "ui-br-agency.title.createAnotherProduct.heading",
        }), message: formatMessage({
            id: "ui-br-agency.title.createAnotherProduct.message",
        }), onConfirm: onConfirm, onCancel: onCancel, confirmLabel: formatMessage({
            id: "ui-br-agency.title.createAnotherProduct.confirm",
        }), cancelLabel: formatMessage({ id: "ui-br-agency.button.cancel" }), buttonStyle: "primary" }));
};
